import  { createRouter, createWebHashHistory } from 'vue-router'
import PreetiToUnicode from "./components/PreetiToUnicode.vue"
import UnicodeToPreeti from "./components/UnicodeToPreeti.vue"
import PageNotFound from "./components/PageNotFound.vue"


function isP2U(){
  return window.location.hostname.startsWith("preeti.lokpath.com")
}

const routes = [
{
  path: '/:pathMatch(.*)*',
  name: 'not-found',
  component: PageNotFound,
    linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
},
  { path: '/', component: isP2U()?PreetiToUnicode:UnicodeToPreeti },
  { path: '/unicode-to-preeti', component: UnicodeToPreeti },
   { path: '/preeti-to-unicode', component: PreetiToUnicode }
]



export const router = createRouter({
    history:createWebHashHistory(),
  routes // short for `routes: routes`
})